import type { QueryProductArgs, Variant } from '@storefront/lib-global/codegen/types';
import type {
  GetVariantsQuery,
  GetVariantsQueryVariables,
} from '@storefront/lib-global/graphqlDocument/product/getVariants.generated';
import { GetVariantsDocument } from '@storefront/lib-global/graphqlDocument/product/getVariants.generated';
import type { ApolloClientInstance } from '@storefront/lib-global/services/gql/apolloClient';
import { logger } from '@storefront/lib-global/utils/logger';

export const getProductVariants = async (
  apolloClient: ApolloClientInstance,
  { input }: QueryProductArgs,
): Promise<{ data?: Variant[]; error?: unknown }> => {
  try {
    const {
      data: { product },
    } = await apolloClient.query<GetVariantsQuery, GetVariantsQueryVariables>({
      query: GetVariantsDocument,
      variables: {
        input,
      },
      fetchPolicy: 'no-cache',
    });

    if (!product || !('variants' in product)) {
      return {
        data: [],
      };
    }

    return {
      data: product.variants || [],
    };
  } catch (error) {
    console.error('Error fetching product variants:', error);
    logger.debug({ error }, 'Error fetching product variants');

    return {
      error,
      data: [],
    };
  }
};
